
import { Outlet } from "react-router-dom";
import { ScrollToTop } from "../components/ScrollToTop";

const MinimalLayout = () => {

  return (
    <main>
      <ScrollToTop />
      <Outlet />
    </main>
  );
};

export default MinimalLayout;
